import React from 'react'
import 'app/sm/renter_background_check_report/components/status-sector/style.scss'

const SectionHeader = ({ statusText = '', statusClass = '' }) => {
  return <span className={`header-status ${statusClass}`}>{statusText}</span>
}

export default SectionHeader
